import { render, staticRenderFns } from "./PopBonusNotification.vue?vue&type=template&id=4d3e4c7a&scoped=true&"
import script from "./PopBonusNotification.vue?vue&type=script&lang=js&"
export * from "./PopBonusNotification.vue?vue&type=script&lang=js&"
import style0 from "./PopBonusNotification.vue?vue&type=style&index=0&id=4d3e4c7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e4c7a",
  null
  
)

export default component.exports